export default {
  BusinessStockDistributionRatioViewForm: {
    basicInformation: '基础信息',
    supportName: '供货仓名称:',
    supportTypeMeaning: '供货仓类型:',
    supportCode: '供货仓编码:',
    receiveName: '接收仓名称:',
    receiveTypeMeaning: '供货仓类型:',
    receiveCode: '供货仓编码:',
    commodityDetails: '商品明细',
    selectGoods: '选择供货仓商品',
    operationLog: '操作日志',
    selectProduct: '选择商品',
    spuNameText: '请输入商品名称',
    spuCodeText: '请输入商品编码',
    skuCodeText: '请输入SKU编码',
    categoryIdText: '请选择分类',
    msgWarning: '商品不能为空',
    confirmText: '此操作会丢失临时新增的数据, 是否继续?',

    table: {
      categoryName: '商品分类',
      spuCode: '商品编码',
      spuName: '商品名称',
      skuCode: 'SKU编码',
      warehouseStructuralQty: '仓库结构比例',
      qty: '商品仓位比例'
    }
  }
};
